// La nouvelle interface, épurée (9 octobre 2026) : la liste des diffuseurs.
export default {
  titre: 'Diffuseurs',
  sousTitre: {
    chaines: 'Part d’audience de {mois}, comparée à {avant} · Médiamétrie, 4 ans et plus',
    chainesSansAvant: 'Part d’audience de {mois} · Médiamétrie, 4 ans et plus',
    chainesSansMesure: 'Qui regarde chaque chaîne, comment sa part d’audience bouge, ce dont son public parle',
    plateformes: 'Les classements que les plateformes publient, et les formats testés pour elles',
  },
  erreur: 'Diffuseurs illisibles',
  type: {
    libelle: 'Type de diffuseur',
    chaines: 'Chaînes',
    plateformes: 'Plateformes',
  },
  recherche: {
    libelle: 'Chercher un diffuseur',
    placeholder: 'Chercher',
  },
  legende: {
    chaines: 'Les chaînes, par part d’audience',
    plateformes: 'Les plateformes',
  },
  colonne: {
    chaine: 'Chaîne',
    plateforme: 'Plateforme',
    pda: 'Part d’audience',
    echelle: 'Échelle',
    surUnMois: 'Sur un mois',
    mesure: 'Mesure',
    formats: 'Formats testés',
    public: 'Son public',
  },
  stable: 'stable',
  compareA: 'comparé à {mois}',
  classementPublie: 'Classement publié',
  horsMediamat: 'Hors Médiamat',
  formatsTestes: '{n} format testé | {n} format testé | {n} formats testés',
  aucunFormat: 'Aucun',
  ouvrir: 'Ouvrir',
  ouvrirLaFiche: 'Ouvrir la fiche de {nom}',
  aucun: {
    chaines: 'Aucune chaîne ne correspond à « {q} ».',
    plateformes: 'Aucune plateforme ne correspond à « {q} ».',
  },
  vide: {
    chaines: 'Aucune chaîne pour l’instant.',
    plateformes: 'Aucune plateforme pour l’instant.',
  },
  note: {
    chaines: 'Médiamat mensuel, 4 ans et plus. Les plateformes ont leur onglet : classements publiés et formats testés.',
    plateformes: 'Les plateformes ne sont pas au Médiamat : ce qui s’y relève, ce sont les classements qu’elles publient.',
  },
}
